import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List } from 'immutable'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { connect as connectPage, PAGE_SEO_TYPE_LOCATION } from '../../Page/connect'
import { connect as connectStaticText } from '../../StaticText/connect'
import { getBoundActions } from '../../../actions/index'
import { getPrimary } from '../../../services/languages/index'
import { TARGET_BLANK } from '../../Link/constants'
import { URL_ACCOUNT } from '../../../services/url/constants'
import { getHelpCenterUrl } from '../../../services/url/index'
import {
  H1,
  H2,
  HEADING_TYPES,
} from '../../Heading/index'
import Button, { TYPES } from '../../Button/index'
import IconV2, { ICON_TYPES } from '../../Icon.v2/index'
import AdyenDropIn from '../../AdyenDropIn/index'
import ErrorMessage from '../../ErrorMessage/index'
import Link from '../../Link/index'
import Sherpa, { TYPE_SMALL_WHITE } from '../../Sherpa/index'
import BackButton from '../../BackButton/index'
import { UPDATE_PAYMENT_ERROR_TYPE_POSTAL_CODE } from '../../../services/update-payment/index'
import { PAYMENT_ERROR_TYPE_POSTAL_CODE } from '../../../services/payment/index'

function MyAccountUpdatePaymentPage (props) {
  const {
    userAccount,
    updatePayment,
    staticText,
    payment,
    resetUpdatePayment,
  } = props
  const processingMessage = staticText.getIn(['data', 'paymentProcessing'])
  const processingStayOnPageMessage = staticText.getIn(['data', 'pleaseStayOnThisPage'])
  const updatePaymentProcessing = updatePayment.get('processing')
  const paymentProcessing = payment.get('paymentDataProcessing')
  const updatePaymentError = updatePayment.get('orderError')
  const paymentError = payment.getIn(['data', 'payments', 'success']) === false || payment.getIn(['data', 'payments', 'error']) === true
  const paymentValidationError = payment.get('error')
  const errorShouldRender = updatePaymentError || paymentError || paymentValidationError
  const updatePaymentSuccess = updatePayment.getIn(['orderData', 'success']) || updatePayment.get('orderComplete')

  const getIframeContainerClassName = (processing) => {
    const baseClassName = 'my-account-update-payment-page__iframe'
    const className = [baseClassName]
    if (processing) {
      className.push(`${baseClassName}--hidden`)
    }
    return className.join(' ')
  }

  const renderPaymentError = () => {
    const {
      user,
    } = props
    let message = staticText.getIn(['data', 'orderErrorMessage'])
    const userLanguage = getPrimary(user.getIn(['data', 'language'], List()))

    if (!errorShouldRender) {
      return null
    }

    if (
      updatePaymentError === UPDATE_PAYMENT_ERROR_TYPE_POSTAL_CODE
      || paymentValidationError === PAYMENT_ERROR_TYPE_POSTAL_CODE
    ) {
      message = staticText.getIn(['data', 'postalCodeErrorMessage'])
    }

    const orderErrorMessages = [
      `${message} `,
      <Link
        key={getHelpCenterUrl(userLanguage)}
        className="error-message__link"
        to={getHelpCenterUrl(userLanguage)}
        directLink
        target={TARGET_BLANK}
      >
        {staticText.getIn(['data', 'orderErrorLink'])}
      </Link>,
    ]

    return (
      <ErrorMessage
        errorMessages={orderErrorMessages}
        errorMessageClass={['my-account-update-payment-page__error-message']}
      />
    )
  }

  const renderLoading = () => {
    return (
      <div className="my-account-update-payment-page">
        <div className="my-account-update-payment-page__placeholder">
          <Sherpa type={TYPE_SMALL_WHITE} />
        </div>
      </div>
    )
  }

  const renderProcessing = () => {
    return (
      <div className="my-account-update-payment-page__processing">
        <Sherpa type={TYPE_SMALL_WHITE} />
        <p className="my-account-update-payment-page__processing-message">
          {processingMessage}
          <br />
          {processingStayOnPageMessage}
        </p>
      </div>
    )
  }

  const renderSuccess = () => {
    return (
      <div className="my-account-update-payment-page">
        <div className="my-account-update-payment-page__success">
        <H1
          as={HEADING_TYPES.H4}
          className="my-account-update-payment-page__title"
        >
          {staticText.getIn(['data', 'title'])}
        </H1>
        <p className="my-account-update-payment-page__secure">
          <IconV2 type={ICON_TYPES.PADLOCK} />
          {staticText.getIn(['data', 'securePayment'])}
        </p>
          <H2
            as={HEADING_TYPES.H5}
            className="dialog-update-payment-success__title"
          >
            {staticText.getIn(['data', 'success'])}
          </H2>
          <p className="dialog-update-payment-success__text">{staticText.getIn(['data', 'sucessBody'])}{'\u00A0'}</p>
          <Button
            className="my-account-update-payment-page__account-button"
            url="/account"
            type={TYPES.PRIMARY}
          >
            {staticText.getIn(['data', 'goToAccount'])}
          </Button>
        </div>
      </div>
    )
  }

  useEffect(() => {
    return () => {
      // reset update payment on unmount
      resetUpdatePayment()
    }
  }, [])

  // prevent from loading until subscription info is in the store
  if (!userAccount.getIn(['details', 'data', 'billing', 'subscriptions'])) {
    return renderLoading()
  }

  // present the success state
  if (updatePaymentSuccess) {
    return renderSuccess()
  }

  return (
    <div className="my-account-update-payment-page">
      <BackButton
        className="my-account-update-payment-page__back-button"
        url={URL_ACCOUNT}
      >
        {staticText.getIn(['data', 'backToAccount'])}
      </BackButton>
      <H1
        as={HEADING_TYPES.H4}
        className="my-account-update-payment-page__title"
      >
        {staticText.getIn(['data', 'title'])}
      </H1>
      <p className="my-account-update-payment-page__secure">
        <IconV2 type={ICON_TYPES.PADLOCK} />
        {staticText.getIn(['data', 'securePayment'])}
      </p>
      {
        updatePaymentProcessing
          ? renderProcessing()
          : null
      }
      <div className={getIframeContainerClassName(updatePaymentProcessing)}>
        {
          renderPaymentError(props)
        }
        <AdyenDropIn
          submitButtonText={
            paymentProcessing
              ? `${staticText.getIn(['data', 'processing'])}...`
              : staticText.getIn(['data', 'save'])
          }
          parentProcessing={updatePaymentProcessing}
          error={!!errorShouldRender}
        />
      </div>
    </div>
  )
}

MyAccountUpdatePaymentPage.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  userAccount: ImmutablePropTypes.map.isRequired,
  payment: ImmutablePropTypes.map.isRequired,
  updatePayment: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      user: state.user,
      userAccount: state.userAccount,
      payment: state.payment,
      updatePayment: state.updatePayment,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        resetUpdatePayment: actions.updatePayment.resetUpdatePayment,
        setUpdatePaymentOrderComplete: actions.updatePayment.setUpdatePaymentOrderComplete,
      }
    },
  ),
  connectStaticText({ storeKey: 'myAccountUpdatePaymentPage' }),
)(MyAccountUpdatePaymentPage)
